import React, { useState, useEffect } from 'react'
import { bankQuestionService } from '../../services/bankQuestionService_moi'

const DSPathDebugTest: React.FC = () => {
  const [debugInfo, setDebugInfo] = useState<any>(null)
  const [loading, setLoading] = useState(false)

  const testDSPath = async () => {
    setLoading(true)
    try {
      // Test path generation
      const testPath = (bankQuestionService as any).getBankPath('10', '1', '1', 'DS')
      console.log('🔍 Generated DS path:', testPath)
      
      // Test path detection
      const detectedType = (bankQuestionService as any).getQuestionTypeFromPath(testPath)
      console.log('🎯 Detected type from path:', detectedType)
      
      // Load actual DS questions
      const dsQuestions = await bankQuestionService.getTrueFalseQuestions('10', '1', '1')
      console.log('📚 Loaded DS questions:', dsQuestions)
      
      // Check first DS question structure
      if (dsQuestions.length > 0) {
        const firstQuestion = dsQuestions[0]
        console.log('🔍 First DS question structure:', {
          id: firstQuestion.id,
          type: firstQuestion.type,
          question_lead: (firstQuestion as any).question_lead,
          statement_a: (firstQuestion as any).statement_a,
          statement_b: (firstQuestion as any).statement_b,
          statement_c: (firstQuestion as any).statement_c,
          statement_d: (firstQuestion as any).statement_d,
          answer_a: (firstQuestion as any).answer_a,
          answer_b: (firstQuestion as any).answer_b,
          answer_c: (firstQuestion as any).answer_c,
          answer_d: (firstQuestion as any).answer_d,
          cau_hoi: firstQuestion.cau_hoi,
          lua_chon: firstQuestion.lua_chon
        })
      }
      
      setDebugInfo({
        path: testPath,
        detectedType,
        questionsCount: dsQuestions.length,
        firstQuestion: dsQuestions[0] || null
      })
      
    } catch (error) {
      console.error('❌ Error in DS path debug:', error)
      setDebugInfo({ error: error.message })
    }
    setLoading(false)
  }

  useEffect(() => {
    testDSPath()
  }, [])

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">DS Path Debug Test</h1>
      
      {loading && (
        <div className="text-blue-600">Loading...</div>
      )}
      
      {debugInfo && (
        <div className="space-y-6">
          <div className="bg-blue-50 p-4 rounded-lg">
            <h2 className="font-semibold mb-2">Path Generation Test:</h2>
            <div className="text-sm space-y-1">
              <div><strong>Generated Path:</strong> {debugInfo.path}</div>
              <div><strong>Detected Type:</strong> {debugInfo.detectedType}</div>
              <div><strong>Questions Count:</strong> {debugInfo.questionsCount}</div>
            </div>
          </div>
          
          {debugInfo.firstQuestion && (
            <div className="bg-green-50 p-4 rounded-lg">
              <h2 className="font-semibold mb-2">First DS Question Structure:</h2>
              <div className="text-sm space-y-1">
                <div><strong>ID:</strong> {debugInfo.firstQuestion.id}</div>
                <div><strong>Type:</strong> {debugInfo.firstQuestion.type}</div>
                <div><strong>question_lead:</strong> {(debugInfo.firstQuestion as any).question_lead || '[MISSING]'}</div>
                <div><strong>statement_a:</strong> {(debugInfo.firstQuestion as any).statement_a || '[MISSING]'}</div>
                <div><strong>statement_b:</strong> {(debugInfo.firstQuestion as any).statement_b || '[MISSING]'}</div>
                <div><strong>statement_c:</strong> {(debugInfo.firstQuestion as any).statement_c || '[MISSING]'}</div>
                <div><strong>statement_d:</strong> {(debugInfo.firstQuestion as any).statement_d || '[MISSING]'}</div>
                <div><strong>answer_a:</strong> {(debugInfo.firstQuestion as any).answer_a || '[MISSING]'}</div>
                <div><strong>answer_b:</strong> {(debugInfo.firstQuestion as any).answer_b || '[MISSING]'}</div>
                <div><strong>answer_c:</strong> {(debugInfo.firstQuestion as any).answer_c || '[MISSING]'}</div>
                <div><strong>answer_d:</strong> {(debugInfo.firstQuestion as any).answer_d || '[MISSING]'}</div>
                <div><strong>cau_hoi:</strong> {debugInfo.firstQuestion.cau_hoi?.substring(0, 100)}...</div>
              </div>
            </div>
          )}
          
          {debugInfo.error && (
            <div className="bg-red-50 p-4 rounded-lg">
              <h2 className="font-semibold mb-2 text-red-700">Error:</h2>
              <div className="text-sm text-red-600">{debugInfo.error}</div>
            </div>
          )}
          
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-semibold mb-2">Debug Instructions:</h3>
            <div className="text-sm text-gray-600 space-y-1">
              <div>1. Kiểm tra console logs để xem path generation</div>
              <div>2. Xem detected type có đúng là 'ds' không</div>
              <div>3. Kiểm tra DS question structure có đầy đủ fields không</div>
              <div>4. Nếu missing fields, cần fix BankQuestionService</div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default DSPathDebugTest